export const FETCH_INSTRUCTORS = 'FETCH_INSTRUCTORS';
export const CREATE_INSTRUCTOR = 'CREATE_INSTRUCTOR';
export const UPDATE_INSTRUCTOR = 'UPDATE_INSTRUCTOR';
export const DELETE_INSTRUCTOR = 'DELETE_INSTRUCTOR';
export const DELETE_INSTRUCTOR_COURSE = 'DELETE_INSTRUCTOR_COURSE';
export const FETCH_INSTRUCTOR = 'FETCH_INSTRUCTOR';
export const UPDATE_INSTRUCTOR_FEATURE = 'UPDATE_INSTRUCTOR_FEATURE';
export const DELETE_INSTRUCTOR_CLASS = 'DELETE_INSTRUCTOR_CLASS';
